import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import es from '../../lang/es';

const HistoryListMobile = props => {
    //Tomo los props
    const { stories, handleOpen } = props;
    //Render
    return (
        <Row className="d-md-none">
            {
                stories ? (
                    stories.map(story => (
                        <Col xs={12} key={`ph${story.histid}`} className="mb-2">
                            <Card>
                                <Card.Header>
                                    <Row>
                                        <Col xs={12}>
                                            <strong>{ story.fecha }</strong>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <h5>{ story.dscr }</h5>
                                    <Button variant="info" size="sm" onClick={() => handleOpen(story)}>
                                        <FontAwesomeIcon icon={ faSearch } /> { es.VIEW_TEXT.toUpperCase() }
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                ) : null
            }
        </Row>
    );
};

export default HistoryListMobile;